import { render, staticRenderFns } from "./SMSOnboardingStepNumber.vue?vue&type=template&id=2041bbf9&scoped=true"
import script from "./SMSOnboardingStepNumber.vue?vue&type=script&lang=js"
export * from "./SMSOnboardingStepNumber.vue?vue&type=script&lang=js"
import style0 from "./SMSOnboardingStepNumber.vue?vue&type=style&index=0&id=2041bbf9&prod&lang=scss&scoped=true"
import style1 from "./SMSOnboardingStepNumber.vue?vue&type=style&index=1&id=2041bbf9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2041bbf9",
  null
  
)

export default component.exports